export const NEW_ORDINE = 'NEW_ORDINE'
export const POST_CLIENTI_CALLBACK = 'POST_CLIENTI_CALLBACK'
export const POST_CLIENTI = 'POST_CLIENTI'
export const PUT_CLIENTI_CALLBACK = 'PUT_CLIENTI_CALLBACK'
export const PUT_CLIENTI = 'PUT_CLIENTI'
export const TRACCIATO_SENT = 'TRACCIATO_SENT'
export const FETCHING = 'FETCHING'
export const ERROR_NOTICE = 'ERROR_NOTICE'
export const GET_TABELLE_DOMINIO_COMPASS = 'GET_TABELLE_DOMINIO_COMPASS'
export const GET_TABELLE_DOMINIO_COMPASS_CALLBACK_SETTOREATTIVITA =
  'GET_TABELLE_DOMINIO_COMPASS_CALLBACK_SETTOREATTIVITA'
export const GET_TABELLE_DOMINIO_COMPASS_CALLBACK_OCCUPAZIONEATTIVITA =
  'GET_TABELLE_DOMINIO_COMPASS_CALLBACK_OCCUPAZIONEATTIVITA'
export const GET_TABELLE_DOMINIO_COMPASS_CALLBACK_CITTADINANZA =
  'GET_TABELLE_DOMINIO_COMPASS_CALLBACK_CITTADINANZA'
export const COMPASS_FILE_UPLOAD_DROPPED = 'COMPASS_FILE_UPLOAD_DROPPED'
export const COMPASS_FILE_UPLOAD_REMOVED = 'COMPASS_FILE_UPLOAD_REMOVED'
export const POST_COMPASS_FILE_UPLOAD = 'POST_COMPASS_FILE_UPLOAD'
export const POST_SLACK = 'POST_SLACK'
export const CLOSE_SLACK_POPUP = 'CLOSE_SLACK_POPUP'
export const BONIFICO_FILE_UPLOAD_DROPPED = 'BONIFICO_FILE_UPLOAD_DROPPED'
export const DISTINTA_FILE_UPLOAD_DROPPED = 'DISTINTA_FILE_UPLOAD_DROPPED'
export const BONIFICO_FILE_UPLOAD_REMOVED = 'BONIFICO_FILE_UPLOAD_REMOVED'
export const POST_BONIFICO_FILE_UPLOAD = 'POST_BONIFICO_FILE_UPLOAD'
export const STORE_RESTORE_INIT = 'STORE_RESTORE_INIT'
export const STORE_RESTORE = 'STORE_RESTORE'
export const STORE_RESTORE_CALLBACK = 'STORE_RESTORE_CALLBACK'
export const STORE_DUMP_IT = 'STORE_DUMP_IT'
export const STORE_DUMP_IT_CALLBACK = 'STORE_DUMP_IT_CALLBACK'
export const STORE_DUMP_IT_FORCE = 'STORE_DUMP_IT_FORCE'
/**
 * BRUM-808
 * PROCESSO D'ACQUISTO: organizzazione integrazione opzioni di consegna/logistica nel frontend
 */
export const GET_LOGISTICA_CENTRI_CONVENZIONATI =
  'GET_LOGISTICA_CENTRI_CONVENZIONATI'
export const NEW_LOGISTICA_CENTRI_CONVENZIONATI =
  'NEW_LOGISTICA_CENTRI_CONVENZIONATI'
export const SET_LOGISTICA_CENTRO_CONVENZIONATO =
  'SET_LOGISTICA_CENTRO_CONVENZIONATO'
export const SET_LOGISTICA_CODICE_PROVINCIA = 'SET_LOGISTICA_CODICE_PROVINCIA'
// BRUM-9771 export const LOGISTICA_MILANO_DEFAULT = 'Milano (consegna rapida)'
export const SET_COMPASS_CALCOLATRICE_LOGISTICA =
  'SET_COMPASS_CALCOLATRICE_LOGISTICA'

/**
 * BRUM-4010
 *
 */
export const GET_CMS_AUTO_V4 = 'GET_CMS_AUTO_V4'
export const GET_CMS_CANONI_V4 = 'GET_CMS_CANONI_V4'
export const GET_NLT_DOCUMENTI_V1 = 'GET_NLT_DOCUMENTI_V1'
export const GET_NLT_SERVIZI_PLUS_V1 = 'GET_NLT_SERVIZI_PLUS_V1'
export const GET_NLT_TABELLE_DOMINIO_CARICA_PRIVATA_V1 =
  'GET_NLT_TABELLE_DOMINIO_CARICA_PRIVATA_V1'
export const GET_NLT_TABELLE_DOMINIO_OCCUPAZIONE_V1 =
  'GET_NLT_TABELLE_DOMINIO_OCCUPAZIONE_V1'
export const GET_NLT_TABELLE_DOMINIO_SETTORE_V1 =
  'GET_NLT_TABELLE_DOMINIO_SETTORE_V1'
export const GET_NLT_TABELLE_DOMINIO_RUOLO_PA_V1 =
  'GET_NLT_TABELLE_DOMINIO_RUOLO_PA_V1'
export const GET_NLT_TABELLE_DOMINIO_SITUAZIONE_ABITATIVA_V1 =
  'GET_NLT_TABELLE_DOMINIO_SITUAZIONE_ABITATIVA_V1'
export const GET_NLT_TABELLE_DOMINIO_SITUAZIONE_LAVORATIVA_V1 =
  'GET_NLT_TABELLE_DOMINIO_SITUAZIONE_LAVORATIVA_V1'
export const GET_NLT_TABELLE_DOMINIO_STATO_CIVILE_V1 =
  'GET_NLT_TABELLE_DOMINIO_STATO_CIVILE_V1'
export const GET_NLT_TABELLE_DOMINIO_TIPOLOGIA_CONTRATTO_V1 =
  'GET_NLT_TABELLE_DOMINIO_TIPOLOGIA_CONTRATTO_V1'
export const NLT_FILE_UPLOAD_DROPPED = 'NLT_FILE_UPLOAD_DROPPED'
export const NLT_FILE_UPLOAD_REMOVED = 'NLT_FILE_UPLOAD_REMOVED'
export const NLT_UPDATE_DATI = 'NLT_UPDATE_DATI'
export const SCEGLI_CANONE_SET_ANTICIPO = 'SCEGLI_CANONE_SET_ANTICIPO'
export const SCEGLI_CANONE_SET_CANONE = 'SCEGLI_CANONE_SET_CANONE'
export const SCEGLI_CANONE_SET_NUMERO_MENSILITA =
  'SCEGLI_CANONE_SET_NUMERO_MENSILITA'
export const SCEGLI_CANONE_SET_CANONE_PERSONALIZZATO =
  'SCEGLI_CANONE_SET_CANONE_PERSONALIZZATO'
export const SERVIZI_PLUS_SELECTED_SERVIZIO = 'SERVIZI_PLUS_SELECTED_SERVIZIO'
export const SERVIZI_PLUS_UNSELECTED_SERVIZIO =
  'SERVIZI_PLUS_UNSELECTED_SERVIZIO'
export const SERVIZI_PLUS_UNSELECT_ALL = 'SERVIZI_PLUS_UNSELECT_ALL'
export const POST_DOCUMENTI_NLT_UPLOAD_V1 = 'POST_DOCUMENTI_NLT_UPLOAD_V1'
export const POST_FINDOMESTIC_FILE_UPLOAD = 'POST_FINDOMESTIC_FILE_UPLOAD'
export const POST_BONIFICO_DISTINTA_FILE_UPLOAD =
  'POST_BONIFICO_DISTINTA_FILE_UPLOAD'
export const POST_NLT_DATI_CLIENTE_V1 = 'POST_NLT_DATI_CLIENTE_V1'
export const POST_ORDINI_NTL_V1 = 'POST_ORDINI_NTL_V1'
export const POST_UTENTI_NLT_V1 = 'POST_UTENTI_NLT_V1'
export const PUT_CLIENTI_V1 = 'PUT_CLIENTI_V1'
export const PUT_ORDINI_SERVIZI_PLUS_V1 = 'PUT_ORDINI_SERVIZI_PLUS_V1'
export const POST_NLT_THANKYOU_V1 = 'POST_NLT_THANKYOU_V1'
export const GET_NLT_CANONE_PERSONALIZZATO_V1 =
  'GET_NLT_CANONE_PERSONALIZZATO_V1'

/**
 * Findomestic
 */
export const FINDOMESTIC_CODICI_ABITAZONE = 'FINDOMESTIC_CODICI_ABITAZONE'
export const FINDOMESTIC_CODICI_CARTA = 'FINDOMESTIC_CODICI_CARTA'
export const FINDOMESTIC_CODICI_DESTINATARIO = 'FINDOMESTIC_CODICI_DESTINATARIO'
export const FINDOMESTIC_CODICI_DOCUMENTO = 'FINDOMESTIC_CODICI_DOCUMENTO'
export const FINDOMESTIC_CODICI_NAZIONALITA = 'FINDOMESTIC_CODICI_NAZIONALITA'
export const FINDOMESTIC_CODICI_PAGAMENTO = 'FINDOMESTIC_CODICI_PAGAMENTO'
export const FINDOMESTIC_CODICI_REPERIBILITA = 'FINDOMESTIC_CODICI_REPERIBILITA'
export const FINDOMESTIC_CODICI_SCADENZA = 'FINDOMESTIC_CODICI_SCADENZA'
export const FINDOMESTIC_CODICI_STATOCIVILE = 'FINDOMESTIC_CODICI_STATOCIVILE'
export const FINDOMESTIC_CODICI_TIPOASSICURAZIONE =
  'FINDOMESTIC_CODICI_TIPOASSICURAZIONE'
export const FINDOMESTIC_CODICI_TIPODOCUMENTOSOGGIORNO =
  'FINDOMESTIC_CODICI_TIPODOCUMENTOSOGGIORNO'
export const FINDOMESTIC_CODICI_TIPOLAVORO = 'FINDOMESTIC_CODICI_TIPOLAVORO'
export const FINDOMESTIC_CODICI_TIPOVEICOLO = 'FINDOMESTIC_CODICI_TIPOVEICOLO'
export const FINDOMESTIC_CODICI_TITOLOSTUDIO = 'FINDOMESTIC_CODICI_TITOLOSTUDIO'
export const FINDOMESTIC_MAPPA_CODICI_LAVORO_SETTORI_ATTIVITA =
  'FINDOMESTIC_MAPPA_CODICI_LAVORO_SETTORI_ATTIVITA'
export const FINDOMESTIC_CODICI_SETTORE_ATTIVITA =
  'FINDOMESTIC_CODICI_SETTORE_ATTIVITA'
export const FINDOMESTIC_UPDATE_DATI = 'FINDOMESTIC_UPDATE_DATI'
export const POST_FINDOMESTIC_DATI_CLIENTE_V1 =
  'POST_FINDOMESTIC_DATI_CLIENTE_V1'
export const POST_FINDOMESTIC_SET_PRATICA = 'POST_FINDOMESTIC_SET_PRATICA'
export const GET_FINDOMESTIC_DOCUMENTI_CLIENTE_V1 =
  'GET_FINDOMESTIC_DOCUMENTI_CLIENTE_V1'
export const FINDOMESTIC_FILE_UPLOAD_DROPPED = 'FINDOMESTIC_FILE_UPLOAD_DROPPED'
export const FINDOMESTIC_FILE_UPLOAD_REMOVED = 'FINDOMESTIC_FILE_UPLOAD_REMOVED'
export const PUT_FINDOMESTIC_DATI_CLIENTE_V1 = 'PUT_FINDOMESTIC_DATI_CLIENTE_V1'
export const PUT_FINDOMESTIC_DATI_CLIENTE_V1_CONIUGE =
  'PUT_FINDOMESTIC_DATI_CLIENTE_V1_CONIUGE'
export const GET_FINANCEMENT_DETAILS = 'GET_FINANCEMENT_DETAILS'
export const GET_FINDOMESTIC_CHECK_FIRMA = 'GET_FINDOMESTIC_CHECK_FIRMA'
export const GET_INFOCERT_CERTIFICATO = 'GET_INFOCERT_CERTIFICATO'
export const POST_INFOCERT_CERTIFICATO = 'POST_INFOCERT_CERTIFICATO'
export const RESET_FINDOMESTIC_PIN = 'RESET_FINDOMESTIC_PIN'
export const FINDOMESTIC_CHECKBOX_CONTRATTO = 'FINDOMESTIC_CHECKBOX_CONTRATTO'
export const FINDOMESTIC_CHECKBOX_ASSICURAZIONI =
  'FINDOMESTIC_CHECKBOX_ASSICURAZIONI'
export const INFOCERT_CHECKBOX_CONTRATTO = 'INFOCERT_CHECKBOX_CONTRATTO'
export const INFOCERT_CHECKBOX_CERTIFICATO = 'INFOCERT_CHECKBOX_CERTIFICATO'
export const POST_FINDOMESTIC_FIRMA_CONTRATTI =
  'POST_FINDOMESTIC_FIRMA_CONTRATTI'
export const POST_FINDOMESTIC_FIRMA_PIN = 'POST_FINDOMESTIC_FIRMA_PIN'
export const FINDOMESTIC_UPDATE = 'FINDOMESTIC_UPDATE'
export const GET_FINDOMESTIC_FIRMA_CONTRATTI = 'GET_FINDOMESTIC_FIRMA_CONTRATTI'

/**
 * FIRMA FINDOMESTIC V2
 */
export const GET_FINDOMESTIC_CHECK_FIRMA_V2 = 'GET_FINDOMESTIC_CHECK_FIRMA_V2'
export const POST_INFOCERT_CERTIFICATO_V2 = 'POST_INFOCERT_CERTIFICATO_V2'
export const GET_INFOCERT_CERTIFICATO_V2 = 'GET_INFOCERT_CERTIFICATO_V2'
export const POST_FINDOMESTIC_FIRMA_CONTRATTI_V2 =
  'POST_FINDOMESTIC_FIRMA_CONTRATTI_V2'

/**
 * BRUM-5806
 */
export const REROUTE_CHECK_DISPONIBILITA = 'REROUTE_CHECK_DISPONIBILITA'

export const SET_CODICE_PREVENTIVO = 'SET_CODICE_PREVENTIVO'
export const GET_ORDINI_CODICE_PREVENTIVO = 'GET_ORDINI_CODICE_PREVENTIVO'

export const SEARCH_COMUNI_LUOGO_NASCITA = 'SEARCH_COMUNI_LUOGO_NASCITA'

export const SEARCH_COMUNI_CITTADINANZA = 'SEARCH_COMUNI_CITTADINANZA'

export const SEARCH_COMUNI_RESIDENZA = 'SEARCH_COMUNI_RESIDENZA'

export const SEARCH_LUOGO_EMISSIONE_PASSAPORTO =
  'SEARCH_LUOGO_EMISSIONE_PASSAPORTO'

export const SEARCH_LUOGO_EMISSIONE_CARTAIDENTITA =
  'SEARCH_LUOGO_EMISSIONE_CARTAIDENTITA'

export const SEARCH_LUOGO_EMISSIONE_PATENTE = 'SEARCH_LUOGO_EMISSIONE_PATENTE'

export const GET_TRANSAZIONI_IBAN = 'GET_TRANSAZIONI_IBAN'

export const GET_FINDOMESTIC_SERVIZI_ASSICURATIVI =
  'GET_FINDOMESTIC_SERVIZI_ASSICURATIVI'

export const FINDOMESTIC_UNSELECT_SERVIZIO_ASSICURATIVO =
  'FINDOMESTIC_UNSELECT_SERVIZIO_ASSICURATIVO'
export const FINDOMESTIC_UNSELECT_ALL_SERVIZI_ASSICURATIVI =
  'FINDOMESTIC_UNSELECT_ALL_SERVIZI_ASSICURATIVI'
export const FINDOMESTIC_SELECT_SERVIZIO_ASSICURATIVO =
  'FINDOMESTIC_SELECT_SERVIZIO_ASSICURATIVO'
export const FINDOMESTIC_CLEAR_FINANZIAMENTO_ASSICURATO =
  'FINDOMESTIC_CLEAR_FINANZIAMENTO_ASSICURATO'
export const POST_FINDOMESTIC_CALCOLATRICE_ASSICURAZIONI =
  'POST_FINDOMESTIC_CALCOLATRICE_ASSICURAZIONI'
export const FINDOMESTIC_SET_DURATA_SERVIZIO_ASSICURATIVO =
  'FINDOMESTIC_SET_DURATA_SERVIZIO_ASSICURATIVO'

// UUID - BRUM-8881
export const SET_UUID = 'SET_UUID'

export const GET_ORDINE_AFTER_RESTORE = 'GET_ORDINE_AFTER_RESTORE'

// BRUMBRUM CLIENTI
export const POST_CLIENTI_BRUMBRUM_V1 = 'POST_CLIENTI_BRUMBRUM_V1'
export const PUT_CLIENTI_BRUMBRUM_V1 = 'PUT_CLIENTI_BRUMBRUM_V1'

export const GET_FINDOMESTIC_PRODOTTI_ASSICURATIVI_FROM_ID_PIANO_RIMBORSO_OUTPUT =
  'GET_FINDOMESTIC_PRODOTTI_ASSICURATIVI_FROM_ID_PIANO_RIMBORSO_OUTPUT'

export const GET_FIRMA_STATUS = 'GET_FIRMA_STATUS'

export const NLT_UPDATE_PAYMENT_METHOD = 'NLT_UPDATE_PAYMENT_METHOD'

export const POST_TRANSAZIONI_CREATE_SEPA_INTENT =
  'POST_TRANSAZIONI_CREATE_SEPA_INTENT'

/** VASS VASS VASSS */

export const GET_ORDINI_SERVIZI_AGGIUNTIVI_V1 =
  'GET_ORDINI_SERVIZI_AGGIUNTIVI_V1'
export const SERVIZI_AGGIUNTIVI_NORMALIZE_SELECTED =
  'SERVIZI_AGGIUNTIVI_NORMALIZE_SELECTED'
export const SERVIZI_AGGIUNTIVI_UNSELECTED_SERVIZIO =
  'SERVIZI_AGGIUNTIVI_UNSELECTED_SERVIZIO'
export const SERVIZI_AGGIUNTIVI_SELECTED_SERVIZIO =
  'SERVIZI_AGGIUNTIVI_SELECTED_SERVIZIO'
export const SERVIZI_AGGIUNTIVI_UNSELECT_ALL = 'SERVIZI_AGGIUNTIVI_UNSELECT_ALL'
export const PUT_ORDINI_SERVIZI_AGGIUNTIVI_V1 =
  'PUT_ORDINI_SERVIZI_AGGIUNTIVI_V1'
export const PUT_VAS_SERVICE_ITEMS = 'PUT_VAS_SERVICE_ITEMS'

// steps
export const POST_LAST_STEP_VISITED_LEAD = 'POST_LAST_STEP_VISITED_LEAD'
export const UPDATE_STEPS_VISITED = 'UPDATE_STEPS_VISITED'
